
import Vue from 'vue'
import StringHelpers from './StringHelpers'
import OrderHelpers from './OrderHelpers'
import EmailHelpers from './EmailHelpers';
import NiceData from '../data/NiceData';
import DataHelpers from './DataHelpers';
import DateHelpers from './DateHelpers';
import {differenceInMinutes} from 'date-fns'


export default class {

    static openWindowWithHtml(title, html) {
        const win = window.open("", title, "toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=400,height=300,top="+(screen.height-200)/2+",left="+(screen.width-150)/2);
        win.document.title = title || 'Taco Snippet'
        win.document.body.innerHTML = html
    }

    static printHtml(html) {
        const winHeight = 530
        const winWidth = 800
        //modified from: https://stackoverflow.com/questions/2255291/print-the-contents-of-a-div

        var winLeft = (screen.width/2)-(winWidth/2)
        var winTop = (screen.height/2)-(winHeight/2)

        var mywindow = window.open('', 'PRINT', `height=${winHeight},width=${winWidth},top=${winTop},left=${winLeft}`)

        mywindow.document.write('<html><head><title>' + document.title  + '</title>')
        mywindow.document.write('</head><body >')
      
        mywindow.document.write(html)
        mywindow.document.write('</body></html>')

        mywindow.document.close()
        mywindow.focus() 

        mywindow.print()
        mywindow.close()

        return true

    }

    static focusById(id) {
        setTimeout(() => {
            const region = document.getElementById(id)
            if(!region) {
                console.log('focusById id not found', id)
                return
            }
            try {
                region.focus()
            } catch(e) {}
            const targetInput = region.getElementsByTagName('input')[0]
            if(targetInput)
                targetInput.focus()
        },200)
    }

    //focus: sets the focus (and optionally selects the text) within a component. target must have a 'ref'
    // context should be set to 'this' in the vue component

    static focus(context, refName, select = false, preventScroll = false, retry = 0) {    
        if(this.isMobile())
            return       
        setTimeout( () => {
            const targetComponent = context.$refs[refName]
            if(targetComponent) {
                const targetInput = (targetComponent.focus ? targetComponent : targetComponent.$el.getElementsByTagName('input')[0])
                
                targetInput.focus({
                    preventScroll
                })

                if(retry)
                    console.log('focus set after ' + retry + ' retries' )
                
                if(select) {
                    targetInput.select()
                }
            } else {                    //retry 3 times
                if(retry > 3)
                    console.log('Cant set focus...retry count exceeded for ref' + refName)
                else
                    this.focus(context, refName, select, preventScroll, retry + 1)
            }    
        }, 200)
    }

    static log(...params) {
        console.log(...params)
    }

    static isPhoneNumber(str) {
        if(!str)
            return false
        str = str.replace(/\D/g,'')
        return (str.length == 10 && str.charAt(0) == '0' )
    }

    static toFaxAddress(faxNumber) {

        faxNumber = faxNumber.replace(/\D/g,'').replace('0', '61')

        if(faxNumber.length != 11) {
            console.error('Invalid fax no provided', faxNumber)
            return
        }

        return faxNumber + '@fax.utbox.net'
    }
    
    static sendSMS (message, mobile) {

        console.log('Utilities > sendSMS (ACTIVE)', message, mobile)
        //return

        mobile = mobile.replace(/\D/g,'').replace('0', '61')

        if(mobile.length != 11) {
            console.error('Invalid mobile provided', mobile)
            return
        }

        let to = mobile + '@sms.utbox.net'

        let email = {
            to,
            subject: message,
            body: message,
        }
        

        EmailHelpers.sendEmail(email)

        return 
    }

    static isMobile () {
        let result =  /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
        
        return result
    }

    static clearProperties (obj) {
        console.log('Clearing properties for', obj)
        for (var property in obj) {
            if (obj.hasOwnProperty(property)) {
                    Vue.set(obj, property, null)
            }
        }
    }

    static removeUndefinedProperties (obj) {
        for (var property in obj) {
            if (obj.hasOwnProperty(property)) {
                if(typeof obj[property] == 'undefined') {
                    Vue.set(obj, property, null)
                    console.log('*WARN* Utilities > removeUndefinedProperties replaced null', property)
                }
                if(typeof obj[property] == 'NaN') {
                    Vue.set(obj, property, null)
                    console.log('*WARN* Utilities > removeUndefinedProperties replaced Nan', property)
                }
            }
        }
    }


    //Like a reactive object.assign...
    static copyProperties (sourceObj, destObj) {
        console.log('Utilities > copyProperties')

        for (var property in sourceObj) {
            if (sourceObj.hasOwnProperty(property)) {
                Vue.set(destObj, property, sourceObj[property])
            }
        }
    }

    //assign only if object and prop exist...
    static assignProperty(fromObject, fromProperty, toObject, toProperty) {
        
        if(!fromObject)
            return 
        if(fromObject[fromProperty] == null)
            return
        if(!toProperty)
            toProperty = fromProperty

        toObject[toProperty] = fromObject[fromProperty]
    }

    static transferProperties (sourceObj, destObj) {
        for (var property in sourceObj) {
            if (sourceObj.hasOwnProperty(property) && destObj.hasOwnProperty(property)) {
                Vue.set(destObj, property, sourceObj[property])
            }
        }
    }

    static clone(obj) {
        if(!obj) {
            console.log('Utilities > clone > returning empty object as nothing passed')
            return {}
        }
            
        return JSON.parse(JSON.stringify(obj))
    }

    static blobToDataURL(blob, callback) {
        var a = new FileReader();
        a.onload = function(e) {callback(e.target.result);}
        a.readAsDataURL(blob);
    }

    static checkIfThisWasDone(identifier, minutes = 60) {
        return new Promise( (resolve, reject) => {
            let ref = DataHelpers.getRootRef().child('app/temp/' + identifier)
            NiceData.fetchItemSingle(ref).then(record => {
                if(!record)
                    record = {
                        identifier, 
                        timestamp:'2019-01-01 00:00',
                        meta: {
                            key: identifier,
                            path: 'app/temp'
                        }
                    }
        
                const diff = Math.abs(differenceInMinutes(DateHelpers.backwardsToDate(record.timestamp), new Date()))
                
                if(diff > minutes) {
                    record.timestamp = DateHelpers.nowString()
                    NiceData.saveItem(record)
                    resolve(false)
                } else {
                    resolve (true)
                }
            })                    
          
        })
    }

    static emptyObject(obj) {
        for (var member in obj) delete obj[member]
    }

    static emptyArray(arr) {
        //works with arrays that are referenced as opposed to arr = [] which assigns a new empty array
        while(arr.length > 0) {
            arr.pop()
        }
    }

    static objectToArray(obj) {

        let arr = []
        for(let item in obj) {
            if(obj.hasOwnProperty(item))
                arr.push(item)
        }
        return arr
    }

    static objectToObjectArray(obj) {

        let arr = []
        for(let prop in obj) {
            if(obj.hasOwnProperty(prop))
                arr.push({...obj[prop], '.key': prop})
        }
        return arr
    }

    static arrayToObject(array) {
        let obj = {}
        array.forEach(function(item) {
            obj[item] = true
        })
        return obj
    }

    static copyObject (sourceObj) {
        delete sourceObj['.key']
        delete sourceObj['key']
        delete sourceObj['__proto__']
        for (var property in sourceObj) {
            if (sourceObj.hasOwnProperty(property)) {
                Vue.set(destObj, property, sourceObj[property])
            }
        }
    }

    static arrayToggle(array, value) {
        var index = array.indexOf(value);
    
        if (index === -1) {
            //Vue.set(array, array.length, value)
            array.push(value)
        } else {
            array.splice(index, 1)
        }
    }

    static objectToggle(object, property) {
        if (object[property]) {
            Vue.set(object, property, null)
        } else {
            Vue.set(object, property, true)
        }
    }

    static arrayNextObject(currentObject, array) {
        let currentIndex = array.findIndex(o => o.key == currentObject.key)
        return array[currentIndex + 1] || null
    }

    static arrayPreviousObject(currentObject, array) {
        let currentIndex = array.findIndex(o => o.key == currentObject.key)
        return array[currentIndex - 1] || null
    }    

    static newOrderBefore(currentObject, array) {
        let currentOrder = parseInt(currentObject.order || 1000000)

        let siblings = array.filter(o => o.parent == currentObject.parent).sort(OrderHelpers.sortAscending)
        let previousObject = this.arrayPreviousObject(currentObject, siblings)
        let previousOrder = parseInt(previousObject ? previousObject.order : 0 - StringHelpers.sortKey())
        
        return parseInt((currentOrder + previousOrder) / 2)
    }
    static newOrderAfter(currentObject, array) {
        let currentOrder = parseInt(currentObject.order || 1000000)

        let siblings = array.filter(o => o.parent == currentObject.parent).sort(OrderHelpers.sortAscending)
        let nextObject = this.arrayNextObject(currentObject, siblings)
        let nextOrder = parseInt(nextObject ? nextObject.order : StringHelpers.sortKey())
        
        return parseInt((currentOrder + nextOrder) / 2)
    }

    static updateObjectArray(obj, arr) {
        
        //let newObject = Object.assign({}, obj)
        //let newArray = arr.slice()

        let idx = arr.findIndex(o => o.key == obj.key)

        if(idx >= 0) {
            console.log('updateObjectArray > index found', idx)
            Vue.set(arr, idx, obj)
        }
        else {

            console.log('updateObjectArray > adding new row', obj)
            
            arr.push(obj)  
        }
                
    }   
    
    static isObject(value) {
        return value !== null && typeof value === 'object'
    }

    static objectListToArray(obj) {

        let arr = []
        for(let item in obj) {
            if(obj.hasOwnProperty(item)) {
                let newItem = obj[item]
                newItem.meta = {}
                newItem.meta.key = item
                arr.push(newItem)
            }
        }
        return arr
    }

    static getPropertySafely(obj, propertyName) {
        if(!obj)
            return null
        return obj[propertyName]
    }

    static debounce = (fn, time) => {
        let timeout
      
        return function() {
          const functionCall = () => fn.apply(this, arguments)
          
          clearTimeout(timeout)
          timeout = setTimeout(functionCall, time)
        }
    }

    // eg objectDeepSet(user, 'settings/emailSettings/signature', 'Thanks, Matt')
    // mutates the object

    static objectDeepSet(obj, path, value) {

        if(typeof(value) == 'undefined')
            return
        
        let pieces = path.split('/')
        let deepObj = obj
        for(let n = 0; n < pieces.length; n++) {
            let piece = pieces[n]
            if(n < pieces.length -1) {
                if(!deepObj[piece]) 
                    Vue.set(deepObj, piece, {})
                deepObj = deepObj[piece]
            } else {
                Vue.set(deepObj, piece, value)
            }  
        }
    }

    //path can be array or path/like/this
    static objectDeepGet(obj, path) {
        let pieces
        if(Array.isArray(path))
            pieces = path
        else
            pieces = path.split('/')

        let deepObj = obj
        
        for(let n = 0; n < pieces.length; n++) {
            let piece = pieces[n]
            if(!deepObj[piece]) {
                return null
            }
            deepObj = deepObj[piece]
        }
        return deepObj
    }

}


// WEBPACK FOOTER //
// ./src/helpers/Utilities.js